import React from 'react';
import ModelingHub from './modeling/ModelingHub';

export function Modeling_En() {
  return <ModelingHub language="en" />;
}

export default Modeling_En;
